import { SystemField } from "./system-field";

export class ShopCurrency extends SystemField{
     
     is_base?:number;
     label?:string;
     developer_name?:string;
     rate_to_base?:number;
     ordering?:number;
     company_id?:string;
     rate_method?:string;
     symbo?:string;
     is_active?:number;
     pos_usable?:number;
}
